import React from "react";
import { createBrowserRouter } from "react-router-dom";
import { ErrorPage } from "../components/Error-Page";
import { ApplicationPage } from "../components/Application/ApplicationPage";
import { Root } from "../components/Root";
import { JobsPage } from "../components/Job/JobsPage";
import { JobDetail } from "../components/Job/JobDetail";
import { LandingPage } from "../components/LandingPage/LandingPage";
import { SignIn } from "../components/Sign-In/Sign-In";
import { SignUp } from "../components/Sign-Up/Sign-Up";
import { SignOut } from "../components/Sign-Out/Sign-Out";
import { Dashboard } from "../components/Dashboard/Dashboard";
// import { ApplicationSubmission } from '../components/Application/ApplicationSubmission';
import { ApplicationForm } from "../components/Application/ApplicationForm";
import { ResetPassword } from "../components/Reset-Password/ResetPasswordPage";
import { EnterNewPassword } from "../components/Reset-Password/Enter-New-Password";
import { RequestSignupVerification } from "../components/Sign-Up/Request-sign-up-verification";
import { VerifyAccount } from "../components/Verify-account/Verify-account";
import { ProfileCard } from "../components/Profile/ProfileCard";
import { Verify2faEmail } from "../components/Verify-2fa-email/Verify-2fa-email";
import { SecuritySettings } from "../components/Security-Settings/Security-Settings";
import { IndividualAssessmentsInfo } from "../components/Individual-Assessments/IndividualAssessmentsInfo";
import { Faq } from "../components/Faq/Faq";
import { Terms } from "../components/legal/Terms";
import { PrivacyPolicy } from "../components/legal/PrivacyPolicy";
import { Disclaimer } from "../components/legal/Disclaimer";
import { Maintenance } from "../components/Maintenance/maintenance";
import { Review } from "../components/Review/Review";

export const router = createBrowserRouter([
    {
        path: "/",
        element: <Root />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: "profileCard",
                element: <ProfileCard />,
            },

            {
                path: "application",
                element: <ApplicationPage />,
            },
            {
                path: "applicationSubmit",
                element: <ApplicationForm />,
            },
            {
                path: "jobs",
                element: <JobsPage />,
                children: [
                    {
                        path: ":jobID?",
                        element: <JobDetail />,
                    },
                ],
            },
            {
                path: "",
                element: <LandingPage />,
            },
            {
                path: "signIn",
                element: <SignIn />,
            },
            {
                path: "signUp",
                element: <SignUp />,
            },
            {
                path: "signOut",
                element: <SignOut />,
            },
            {
                path: "dashboard",
                element: <Dashboard />,
            },
            {
                path: "forgotPassword",
                element: <ResetPassword />,
            },
            {
                path: "reset-password",
                element: <EnterNewPassword />,
            },
            {
                path: "request-account-verification",
                element: <RequestSignupVerification />,
            },
            {
                path: "verify-account",
                element: <VerifyAccount />,
            },
            {
                path: "verify-phone",
                element: <Verify2faEmail />,
            },
            {
                path: "security-settings",
                element: <SecuritySettings />,
            },
            {
                path: "individual-assessments",
                element: <IndividualAssessmentsInfo />,
            },
            {
                path: "faq",
                element: <Faq />,
            },
            {
                path: "terms-of-use",
                element: <Terms />,
            },
            {
                path: "privacy-policy",
                element: <PrivacyPolicy />,
            },
            {
                path: "disclaimer",
                element: <Disclaimer />,
            },
            {
                path: "maintenance",
                element: <Maintenance />,
            },
            {
                path: "review",
                element: <Review />,
            },
        ],
    },
]);
